export enum AnalyticsBranchPageEnum {
  BRANCH_PAGE = 'Página de Unidade Física',
  CITY_PAGE = 'Página de Cidade',
}
